import { render, staticRenderFns } from "./SignupSettings.vue?vue&type=template&id=5c563282&"
import script from "./SignupSettings.vue?vue&type=script&lang=js&"
export * from "./SignupSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports